module.exports = __webpack_public_path__ + "nu.76d47b01cc6b3e11d8ea.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/nu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/nu.svg
// module chunks = styles